import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ProductInventoryComponent } from './product-inventory.component';
import { I18nModule, provideConfig } from '@spartacus/core';
import { productInventoryOccConfig } from './core/product-inventory.occ';
import { LocalLoaderComponent } from '../../../../components/loader/local-loader/local-loader.component';
import { AlertComponent } from '../../../../components/alert/alert.component';

@NgModule({
  declarations: [ProductInventoryComponent],
  imports: [CommonModule, RouterModule, I18nModule, LocalLoaderComponent, AlertComponent, DatePipe],
  providers: [provideConfig(productInventoryOccConfig)],
  exports: [ProductInventoryComponent],
})
export class ProductInventoryModule {}
